import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Discount } from "../Types/discountTypes";

export const discountsApi = createGenericApiSlice<Discount>({
	reducerPath: "discountsApi",
	tag: TagTypes.Discount,
	endpoint: "discounts",
});

export const {
	useGetAllQuery: useGetDiscountsQuery,
	useGetByIdQuery: useGetDiscountByIdQuery,
	useCreateMutation: useCreateDiscountMutation,
	useUpdateMutation: useUpdateDiscountMutation,
	useDeleteMutation: useDeleteDiscountMutation,
} = discountsApi;
